import React from 'react'

const NotFound = () => {
    return (
        <p>Sorry we can't find this page</p>
    )
}

export default NotFound
